import { Component, inject, input, output, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportControl } from '@xmedical/core';

@Component({
  selector: 'xmed-date-picker-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
  ],
  providers: [DatePipe],
  templateUrl: './date-picker-renderer.component.html',
  styleUrl: './date-picker-renderer.component.scss'
})
export class DatePickerRendererComponent implements OnInit {
  private datePipe = inject(DatePipe);

  control = input.required<ReportControl>();
  value: Date = new Date();

  valueChanged = output<void>();

  ngOnInit(): void {
    const ctrl = this.control();
    if (ctrl?.value === '') {
      ctrl.value = this.datePipe.transform(this.value, 'YYYY-MM-dd') ?? '';
    }
    if (ctrl?.value !== '') {
      this.value = new Date(ctrl.value);
    }
  }

  onValueChanges(date: Date): void {
    this.control().value = this.datePipe.transform(date, 'YYYY-MM-dd') ?? '';
    this.valueChanged.emit();
  }
}
